import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideIndustrieStub } from '../../../../config/aides-industrie';

export default function CeeIndPage() {
  const aide = getAideIndustrieStub('cee-ind');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="industrie" />;
}
